var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { EventEmitter } from 'events';
import { AppJsApi } from './../common/config';
import loadJs from '../common/loadjs';
import { createDeeplink } from '../common/scheme';
import { AppDownloadStatus } from '../../../common/constants';
import { errorLogger } from '../../debug';
import { AppPackage } from '../common/appInfo';
import Platform from "./../common/plat";
/**
 * QB下载器实现
 * 相关文档：http://exp.qbjsapi.wsd.com
 */
var QBDownloader = /** @class */ (function (_super) {
    __extends(QBDownloader, _super);
    function QBDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'QBDownloader';
        _this.opt = __assign({}, opt);
        _this.reuseApkInfo = {};
        return _this;
    }
    QBDownloader.prototype.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadJs(AppJsApi.QB)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    QBDownloader.prototype.start = function () {
        var _a, _b;
        var _c = this.opt, url = _c.url, reportstring = _c.reportstring, qbreportstring = _c.qbreportstring, needautoinstall = _c.needautoinstall, _d = _c.needdialog, needdialog = _d === void 0 ? 'false' : _d, _e = _c.neednotification, neednotification = _e === void 0 ? 'false' : _e, _f = _c.needtoast, needtoast = _f === void 0 ? 'false' : _f, rest = __rest(_c, ["url", "reportstring", "qbreportstring", "needautoinstall", "needdialog", "neednotification", "needtoast"]);
        if (Platform.isIos) {
            return location.href = url;
        }
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.startDownload) {
            window.browser.download.startDownload(__assign(__assign({ url: url, needautoinstall: needautoinstall, needdialog: needdialog, neednotification: neednotification, needtoast: needtoast }, rest), { reportstring: qbreportstring }));
        }
        else {
            this.emit('apierror', 'startDownload');
            errorLogger('异常:', 'startDownload', '无此方法');
        }
    };
    QBDownloader.prototype.pause = function () {
        var _a, _b;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.pauseDownload) {
            window.browser.download.pauseDownload({ url: url });
        }
        else {
            errorLogger('异常:', 'pauseDownload', '无此方法');
        }
    };
    QBDownloader.prototype.resume = function () {
        this.start();
    };
    QBDownloader.prototype.install = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var _d, url, channelId, _e, autoReuse, apkSource;
            var _this = this;
            return __generator(this, function (_f) {
                _d = this.opt, url = _d.url, channelId = _d.channelId, _e = _d.autoReuse, autoReuse = _e === void 0 ? false : _e, apkSource = _d.apkSource;
                // 复用包场景
                if (autoReuse && apkSource && ((_a = this.reuseApkInfo) === null || _a === void 0 ? void 0 : _a.pkg) && ((_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.download) === null || _c === void 0 ? void 0 : _c.reuseApk)) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            var _a, _b;
                            var apkInfo = __assign(__assign({}, _this.reuseApkInfo), { channel: channelId });
                            return (_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.reuseApk(function (res) {
                                resolve(true);
                            }, function (err) { return __awaiter(_this, void 0, void 0, function () {
                                var status;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.start()];
                                        case 1:
                                            status = _a.sent();
                                            resolve(status);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, apkInfo);
                        })];
                }
                else {
                    errorLogger('异常:', 'reuseApk', '无此方法');
                }
                new Promise(function (resolve) {
                    var _a, _b;
                    if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.installApp) {
                        window.browser.download.installApp({ url: url }, function (res) {
                            resolve(!!res.install);
                        });
                    }
                    else {
                        resolve(false);
                        _this.emit('error', status);
                        errorLogger('异常:', 'installApp', '无此方法');
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    QBDownloader.prototype.open = function () {
        var _a, _b;
        var _c = this.opt, packagename = _c.packagename, active = _c.active;
        if ([AppPackage.QB, AppPackage.QBJS, AppPackage.QBNOVEL].includes(packagename)) {
            return location.href = active;
        }
        if (active) {
            location.href = active;
        }
        else if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.runApk) {
            window.browser.app.runApk(packagename);
        }
        else {
            errorLogger('异常:', 'runApk', '无此方法');
            location.href = createDeeplink(packagename);
        }
    };
    QBDownloader.prototype.isInstalled = function () {
        var packagename = this.opt.packagename;
        return new Promise(function (resolve, reject) {
            var _a, _b;
            if (Platform.isQB && AppPackage.QB === packagename) {
                resolve(true);
            }
            if (Platform.isQBJS && AppPackage.QBJS === packagename) {
                resolve(true);
            }
            if (Platform.isQBNOVEL && AppPackage.QBNOVEL === packagename) {
                resolve(true);
            }
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.isInstallApk) {
                window.browser.app.isInstallApk(function (installed) {
                    resolve(installed);
                }, { packagename: packagename });
            }
            else {
                resolve(false);
                errorLogger('异常:', 'isInstallApk', '无此方法');
            }
        });
    };
    QBDownloader.prototype.getStatus = function () {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var _g, packagename, url, _h, autoReuse, apkSource, status_1;
            var _this = this;
            return __generator(this, function (_j) {
                _g = this.opt, packagename = _g.packagename, url = _g.url, _h = _g.autoReuse, autoReuse = _h === void 0 ? false : _h, apkSource = _g.apkSource;
                // 判断是否有复用
                if (autoReuse && apkSource && ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.findApk) && ((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.download) === null || _d === void 0 ? void 0 : _d.reuseApk)) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            window.browser.download.findApk(function (res) {
                                _this.reuseApkInfo = __assign(__assign({}, res), { apkSource: apkSource });
                                resolve(AppDownloadStatus.TASK_STATUS_COMPLETED);
                            }, function (msg) {
                                resolve(AppDownloadStatus.TASK_STATUS_NONE);
                            }, {
                                pkg: packagename,
                                vc: 1,
                                apkSource: apkSource,
                                vcCompareMode: 'GreaterThan'
                            });
                        })];
                }
                else {
                    errorLogger('异常:', 'findApk', '无此方法');
                }
                if ((_f = (_e = window === null || window === void 0 ? void 0 : window.browser) === null || _e === void 0 ? void 0 : _e.download) === null || _f === void 0 ? void 0 : _f.getDownloadStatus) {
                    status_1 = window.browser.download.getDownloadStatus({ url: url });
                    if (['TASK_STATUS_TIMEOUT', 'TASK_STATUS_FAILED'].includes(status_1)) {
                        this.emit('apierror', status_1);
                    }
                    return [2 /*return*/, status_1];
                }
                else {
                    errorLogger('异常:', 'getDownloadStatus', '无此方法');
                }
                return [2 /*return*/];
            });
        });
    };
    QBDownloader.prototype.getProgress = function () {
        var _this = this;
        var url = this.opt.url;
        return new Promise(function (resolve, reject) {
            var _a, _b;
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.getDownloadInfo) {
                window.browser.download.getDownloadInfo(function (_a) {
                    var res = _a.res;
                    var progress = 0;
                    try {
                        var _b = res[0], downedsize = _b.downedsize, totalsize = _b.totalsize;
                        if (!Number.isNaN(parseInt(totalsize)) && parseInt(totalsize) !== 0) {
                            progress = Math.floor(downedsize / totalsize * 100);
                        }
                    }
                    catch (e) {
                        _this.emit('apierror', '任务未创建');
                    }
                    resolve(progress);
                }, function (_a) {
                    var res = _a.res;
                    resolve(0);
                }, { 'urllist': JSON.stringify([{ url: url }]) });
            }
            else {
                resolve(0);
                errorLogger('异常:', 'getDownloadInfo', '无此方法');
            }
        });
    };
    return QBDownloader;
}(EventEmitter));
export default QBDownloader;
